<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="300">
      <v-card>
        <v-card-title class="text-uppercase">
          <h5>Decline invitation</h5>
        </v-card-title>
        <v-card-text>
          Are you sure you want to decline this invitation?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog"> Cancel </v-btn>
          <v-btn color="red darken-1" text @click="confirmDecline">
            Yes, decline
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["open"],

  data: () => ({
    dialog: false,
  }),

  watch: {
    open(value) {
      this.dialog = value;
    },
  },

  methods: {
    closeDialog() {
      this.$emit("cancel");
      this.dialog = false;
    },
    confirmDecline() {
      this.$emit("confirm");
      this.dialog = false;
    },
  },
};
</script>